import { render, staticRenderFns } from "./Base_dic.vue?vue&type=template&id=5f904c14&scoped=true&"
import script from "./Base_dic.vue?vue&type=script&lang=js&"
export * from "./Base_dic.vue?vue&type=script&lang=js&"
import style0 from "./Base_dic.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Base_dic.vue?vue&type=style&index=1&id=5f904c14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f904c14",
  null
  
)

export default component.exports